// เปิดผลสุ่มทีละชั้น: กลุ่ม → กลุ่มย่อย → ชนิด (docs/PLAN.md ข้อ 7)

import type { SpawnResult } from "../../shared/api";
import { groupNames } from "../names";

interface Props {
  spawn: SpawnResult;
  onContinue: () => void;
}

export function Reveal({ spawn, onContinue }: Props) {
  const { group, subgroup } = groupNames(spawn.species.subgroupId);
  return (
    <main className="screen center" onClick={onContinue}>
      <p className="reveal-step d1 reveal-label">คุณเกิดเป็น…</p>
      <div className="reveal-step d1">
        <p className="reveal-label">กลุ่ม</p>
        <p className="reveal-value">{group}</p>
      </div>
      <div className="reveal-step d2">
        <p className="reveal-label">กลุ่มย่อย</p>
        <p className="reveal-value">{subgroup}</p>
      </div>
      <div className="reveal-step d3">
        <p className="reveal-name">{spawn.species.nameTh ?? spawn.species.sci}</p>
        <p className="sci">{spawn.species.sci}</p>
      </div>
      {/* แตะตรงไหนก็ได้เพื่อข้ามแอนิเมชัน ปุ่มนี้ใช้ click ที่ส่งต่อขึ้นไปถึง main */}
      <div className="reveal-step d4">
        <button type="button" className="btn primary block">
          ดูการ์ดสัตว์
        </button>
      </div>
    </main>
  );
}
